module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-individual-90f6e1f654e37c825e32010701954fa2.png";